import script from "./WalletBadges.vue?vue&type=script&lang=ts&setup=true"
export * from "./WalletBadges.vue?vue&type=script&lang=ts&setup=true"

import "./WalletBadges.vue?vue&type=style&index=0&id=1a2f08ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a2f08ee"]])

export default __exports__